import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { TriangleWarning } from "components/icons/TriangleWarning";
import { useModal } from "hooks/useModal";
import React from "react";

export const Confirm1099FilingComplete = ({
  moveToNextState,
}: {
  moveToNextState: () => void;
}) => {
  const availabilityModal = useModal();

  const handleSubmit = () => {
    moveToNextState();
    availabilityModal.close();
  };

  return (
    <Modal.Root
      onOpenChange={availabilityModal.toggle}
      open={availabilityModal.isOpen}
    >
      <Modal.Trigger asChild>
        <Button customType="primary" size="regular">
          Complete filing
        </Button>
      </Modal.Trigger>
      <Modal.Content useCustomOverlay size="small">
        <Modal.Body>
          <div>
            <span className="t-text-orange t-flex t-items-center t-justify-center t-w-10 t-h-10 t-rounded-full t-shadow-[0px_0px_0px_4px_rgba(255,220,78,0.15)] t-border t-border-orange-20 t-border-solid t-bg-yellow-20">
              <TriangleWarning />
            </span>
            <p className="t-mb-2 t-text-subtext t-mt-5">
              Confirm filing completion
            </p>
            <div className="t-text-body-sm t-text-text-30">
              You’re about to mark this filing as completed. Please make sure
              all details are accurate and complete.
            </div>
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button onClick={handleSubmit} customType="primary">
            Confirm completion
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
